import React, { useState } from "react"
import DeleteModal from "../../../components/Common/DeleteModal"
import { usePagination } from "../../../hooks/usePagination"
import { useTranslation } from "react-i18next"
import { useResponse } from "../../../hooks/useResponse"
import TableAction from "../../../components/TableAction"
import EmptyData from "../../../components/EmptyData"
import { Table, Thead, Tbody, Td, Tr, Th } from "react-super-responsive-table"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import { PERMISSIONS } from "../../../api/permissions";
import { Button } from "reactstrap"
import { deleteWorkExperience, getAllWorkExperiences } from "../../../api/workExperience"
import moment from "moment"
import { useHistory } from "react-router-dom"
import PaginationHandler from "../../../components/PaginationHandler"
import ResultHandler from "../../../components/ResultHandler"

const ExperienceTable = ({employeeId}) => {   
    const { t } = useTranslation()
    const navigate = useHistory()
    const {
      response,
      loading,
      error,
      setPage,
      page,
      totalPages,
      setPayload,
    } = usePagination(getAllWorkExperiences, {employeeId})

    //// delete 
    const [show, setShow] = useState(false)
    const [deletingWorkExperience, setDeletingWorkExperience] = useState(null)
    
    const { setData } = useResponse(deleteWorkExperience, () => {
      setShow(false)
      setDeletingWorkExperience(null)
      setPayload({employeeId, ref: true})
    })

    function onCloseClick() {
      setShow(false)
    }
  
    function onDeleteClick() {
      setData({ type: "delete", data: deletingWorkExperience})
    }
    
  return (
    <div className="table-rep-plugin">
      <div className="table-responsive">
        <Table className="table table-striped table-bordered">
          <Thead className="table-light table-nowrap">
            <Tr>
              <Th>Number</Th>
              <Th>From</Th>
              <Th>To</Th>
              <Th>What</Th>
              <Th>Company</Th>
              <Th className="text-center" style={{ width: "20%" }}>{t("tables.Action")}</Th>
            </Tr>
          </Thead>

          {response.data && !loading && (
            <Tbody>
              {response.data.experience.map((row,idx) => {
                return (
                  <Tr key={row.id}>
                    <Td>{idx+1}</Td>
                    <Td>{moment(row.from).format("DD MMM YYYY")}</Td>
                    <Td>{moment(row.to).format("DD MMM YYYY")}</Td>
                    <Td>{row.jobTitle}</Td>
                    <Td>{row.company}</Td>
                    <Td className="text-center">
                      <TableAction
                        hasEdit={true}
                        hasDelete={true}
                        editPermission={PERMISSIONS.EMPLOYEE_EDIT}
                        deletePermission={PERMISSIONS.EMPLOYEE_DELETE}
                        type="work-experience"
                        id={row.id}
                        setShow={setShow}
                        setDeleteIntitiy={setDeletingWorkExperience}
                      />
                    </Td>
                  </Tr>
                )
              })}
            </Tbody>
          )}
        </Table>

        {!loading &&
          <EmptyData empty={response.data && response.data.experience.length === 0} msg="No Experience Found." />
        }

        {!loading && (
          <div className="d-flex" style={{justifyContent: "flex-end", marginTop: "20px"}}>
            <Button color="dark" onClick={() => navigate.push("/add-work-experience/" + employeeId)}>Add</Button>
          </div>
        )}

        {response.data && !loading && (
          <PaginationHandler
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        )}

        <ResultHandler error={error} loading={loading} />

        <DeleteModal
          show={show}
          onDeleteClick={onDeleteClick}
          onCloseClick={onCloseClick}
        />

      </div>
    </div>
  )
}

export default ExperienceTable